import { Component, OnInit } from "@angular/core";
import { keysToTranslate } from "i18n/keys-to-translate";
import { FormatConfigService } from "../../core/services/format-config.service";
import { SettingsConfigResponse } from "../../core/base-api";

@Component({
  selector: "cap-environment-marker",
  templateUrl: "./environment-marker.component.html",
  styleUrls: ["./environment-marker.component.scss"],
})
export class EnvironmentMarkerComponent implements OnInit {
  environmentName: string;
  environmentColor: string;

  private defaultColorEntwicklungsumgebung = "#779ECB";
  private defaultColorTestumgebung = "#8acb77";

  backgroundStyle;

  constructor(private appformatConfigService: FormatConfigService) {
    keysToTranslate<string>([
      "layouts.entwicklungsUmgebung",
      "layouts.testUmgebung",
    ]);
  }

  ngOnInit() {
    if (this.appformatConfigService.settingsConfig) {
      this.configUmgebung(this.appformatConfigService.settingsConfig);
    } else {
      this.appformatConfigService.settingsConfig$.subscribe((config) => {
        this.configUmgebung(config);
      });
    }
  }

  private configUmgebung(settingsConfig: SettingsConfigResponse) {
    if (!settingsConfig) {
      return;
    }
    const customColorEntwicklung = EnvironmentMarkerComponent.getHexValue(
      this.appformatConfigService.settingsConfig.colorUmgebung
    );

    if (
      this.appformatConfigService.settingsConfig.nameUmgebung === "Testumgebung"
    ) {
      this.environmentName = "layouts.testUmgebung";
      this.environmentColor = this.isValidHexColor(customColorEntwicklung)
        ? customColorEntwicklung
        : this.defaultColorTestumgebung;
    } else if (
      this.appformatConfigService.settingsConfig.nameUmgebung ===
      "Entwicklungsumgebung"
    ) {
      this.environmentName = "layouts.entwicklungsUmgebung";
      this.environmentColor = this.isValidHexColor(customColorEntwicklung)
        ? customColorEntwicklung
        : this.defaultColorEntwicklungsumgebung;
    } else {
      this.environmentName =
        this.appformatConfigService.settingsConfig.nameUmgebung;
      this.environmentColor = this.isValidHexColor(customColorEntwicklung)
        ? customColorEntwicklung
        : null;
    }
    this.configBackgroundStyle();
  }

  private configBackgroundStyle() {
    this.backgroundStyle = {
      "background-color": this.environmentColor,
    };
  }

  private static getHexValue(color: string) {
    if (color) {
      return color.startsWith("#") ? color : "#" + color;
    }
    return null;
  }

  isValidHexColor(color: string) {
    return color && /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
  }
}
